// test1152
(1152 && 0);
